import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import MyModalProdotti from "../widgets/MyModalProdotti";
import MyModalGiacenze from "../widgets/MyModalGiacenze";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";

//apis
import getGiacenze from "../services/getGiacenze";
import getProdotti from "../services/getProdotti";
import getFornitori from "../services/getFornitori";
import getGiacenzeIngresso from "../services/getGiacenzeIngresso";
import getGiacenzeUscita from "../services/getGiacenzeUscita";
import checkToken from "../services/checkToken";
import moment from "moment";
import getGiacenzeFuture from "../services/getGiacenzeFuture";
import DatePickerIta from "../widgets/DatePickerMUI";
import { Box } from "@material-ui/core";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class GiacenzeMagazzino extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            modal_prodotto: {
                nome: '',
                show: false,
                id: null,
            },
            modal_info: {
                show: false,
                id: null,
            },
            dataTarget: this.startDate(),
            dataCheck: moment().format('DD/MM/YYYY'),
        };
    }

    startDate = () => {
        let today = new Date();
        today.setMonth(today.getMonth() + 1);
        let date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
        return date
    }

    reload = async () => {
        this.setState({ isLoading: true });
        if (this.state.dataCheck === moment().format('DD/MM/YYYY')) {

            let giacenze = await getGiacenze(username, token);
            let prodotti = await getProdotti(username, token);
            let giacenze_ingresso = await getGiacenzeIngresso(username, token);
            let giacenze_uscita = await getGiacenzeUscita(username, token);
            let fornitori = await getFornitori(username, token);

            const check = await checkToken(username, token, true);
            const userType = parseInt(check.utente.tipo);

            giacenze.forEach(giacenza => {
                let prodotto = prodotti.find(p => p.id === giacenza.id_prodotto);
                let uscite = giacenze_uscita.find(g => g.id === giacenza.id_prodotto);
                let ingressi = giacenze_ingresso.find(g => g.id_prodotto === giacenza.id_prodotto);

                giacenza['nome'] = prodotto ? prodotto.nome : 'Prodotto non trovato';
                giacenza['giacenza_max'] = prodotto ? prodotto.giacenza_max : '0';
                giacenza['giacenza_min'] = prodotto ? prodotto.giacenza_min : '0';
                giacenza['ingresso'] = ingressi ? ingressi.ingresso : 0;
                giacenza['uscita'] = uscite ? uscite.quantita : 0;
                giacenza['saldo'] = parseInt(giacenza['giacenza']) + parseInt(giacenza['ingresso']) - parseInt(giacenza['uscita']);
                giacenza['stato'] = (
                    giacenza['saldo'] >= giacenza['giacenza_min'] &&
                    giacenza['saldo'] <= giacenza['giacenza_max']
                ) ? 'stato_ok' : 'stato_ko'
                giacenza['info'] = 'info'
            });

            giacenze_ingresso.filter(g => !giacenze.find(giacenza => giacenza.id_prodotto === g.id_prodotto)).forEach(giacenza => {
                let prodotto = prodotti.find(p => p.id === giacenza.id_prodotto);
                let uscita = giacenze_uscita.find(g => g.id === giacenza.id_prodotto);

                giacenze.push({
                    'nome': prodotto ? prodotto.nome : 'Prodotto non trovato',
                    'giacenza_max': prodotto ? prodotto.giacenza_max : '0',
                    'giacenza_min': prodotto ? prodotto.giacenza_min : '0',
                    'giacenza': 0, 
                    'ingresso': giacenza.ingresso,
                    'uscita': uscita ? uscita.quantita : 0,
                    'saldo': parseInt(giacenza['ingresso']) - parseInt(uscita ? uscita.quantita : 0),
                    'stato': (
                        giacenza['saldo'] >= giacenza['giacenza_min'] &&
                        giacenza['saldo'] <= giacenza['giacenza_max']
                    ) ? 'stato_ok' : 'stato_ko',
                    'info': 'info'
                });
            });

            giacenze_uscita.filter(g => !giacenze.find(giacenza => giacenza.id_prodotto === g.id)).forEach(giacenza => {
                let prodotto = prodotti.find(p => p.id === giacenza.id);
                let ingresso = giacenze_ingresso.find(g => g.id_prodotto === giacenza.id);

                giacenze.push({
                    'nome': prodotto ? prodotto.nome : 'Prodotto non trovato',
                    'giacenza_max': prodotto ? prodotto.giacenza_max : '0',
                    'giacenza_min': prodotto ? prodotto.giacenza_min : '0',
                    'giacenza': 0,
                    'ingresso': ingresso ? ingresso.ingresso : 0,
                    'uscita': giacenza.quantita,
                    'saldo': parseInt(ingresso ? ingresso.ingresso : 0) - parseInt(giacenza['quantita']),
                    'stato': (
                        giacenza['saldo'] >= giacenza['giacenza_min'] &&
                        giacenza['saldo'] <= giacenza['giacenza_max']
                    ) ? 'stato_ok' : 'stato_ko',
                    'info': 'info'
                });
            });


            this.setState({ isLoading: false, giacenze, fornitori, userType, prodotti });
        } else {

            let giacenze = await getGiacenzeFuture(username, token, this.state.dataCheck.replace(/\//g, '-'));
            let prodotti = await getProdotti(username, token);
            let rows = giacenze.map((giacenza) => {
                let prodotto = prodotti.find(p => p.id === giacenza.id);
                return {
                    info: '',
                    nome: prodotto ? prodotto.nome : 'Prodotto non trovato',
                    saldo: giacenza.giacenza,
                }
            });
            this.setState({ isLoading: false, giacenze: rows });
        }
    }


    close = () => {
                let modal_prodotto = this.state.modal_prodotto;
                let modal_info = this.state.modal_info;
                modal_prodotto.show = false;
                modal_info.show = false;
                this.setState({ modal_prodotto, modal_info });
            }

    openInfoPanel = (row) => {
        let modal_info = this.state.modal_info;
        modal_info.show = true;
        modal_info.id = row.id_prodotto;
        modal_info.nome = row.nome;
        this.setState({ modal_info });
    }

    componentDidMount() {

            username = cookies.get('username', { path: '/' });
            token = cookies.get('token', { path: '/' });

            this.reload()
        }

    render() {
            if(this.state.isLoading)
        return <Loading />;

        var headCells = [];

        if (this.state.dataCheck === moment().format('DD/MM/YYYY')) {
            headCells = [
                { id: 'nome', numeric: false, disablePadding: true, label: 'Prodotto' },
                { id: 'giacenza', numeric: false, disablePadding: false, label: 'In Magazzino' },
                { id: 'ingresso', numeric: true, disablePadding: false, label: 'In Arrivo' },
                { id: 'uscita', numeric: true, disablePadding: false, label: 'In Uscita' },
                { id: 'saldo', numeric: true, disablePadding: false, label: 'Saldo' },
                { id: 'stato', numeric: true, disablePadding: false, label: 'Stato', icon: true },
            ];
        } else {
            headCells = [
                { id: 'info', numeric: true, disablePadding: false, label: '', icon: true },
                { id: 'nome', numeric: false, disablePadding: true, label: 'Prodotto' },
                { id: 'saldo', numeric: true, disablePadding: false, label: 'Saldo' },
            ];
        }

        this.searchCols = ['nome', 'giacenza', 'stato'];

        if (headCells.find(h => h.id === '_') === undefined) {
            headCells.push({ id: '_', numeric: true, disablePadding: false, label: '' });
        }

        return (
            <div>
                <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="end">
                    <PageTitle title="Giacenze Magazzino" />
                    <Box>
                        <DatePickerIta
                            format='DD/MM/YYYY'
                            grow
                            label="Data"
                            disablePast
                            startValue={this.state.dataCheck}
                            onValueChange={(date) => {
                                this.setState({ dataCheck: date });
                                this.reload();
                            }}
                        />
                    </Box>
                </Box>




                {this.state.dataCheck === moment().format('DD/MM/YYYY') &&
                    <Table
                    headCells={headCells}
                    rows={this.state.giacenze}
                    searchCols={this.searchCols}
                    onEventMagazzinoClick={(row) => {
                        this.setState({
                            modal_prodotto: {
                                show: true,
                                id: this.state.prodotti.find(p => p.nome === row.nome)?.id,
                                nome: row.nome,
                            }
                        })
                    }}
                    onOpenInfoPanel={this.openInfoPanel.bind(this)}
                />}
                
                {this.state.dataCheck !== moment().format('DD/MM/YYYY') && <Table
                    headCells={headCells}
                    rows={this.state.giacenze}
                    searchCols={this.searchCols}
                />}

                {
                    this.state.modal_prodotto.show &&
                    <MyModalProdotti
                        modal={this.state.modal_prodotto}
                        prodotto={this.state.modal_prodotto.id}
                        title={this.state.modal_prodotto.nome}
                        fornitori={this.state.fornitori}
                        onClose={this.close}
                        onReload={() => this.reload()}
                        isUserType={this.state.userType}
                    />
                }

                {
                    this.state.modal_info.show &&
                    <MyModalGiacenze
                        modal={this.state.modal_info}
                        title={this.state.modal_info.nome}
                        onClose={this.close}
                    />
                }
            </div>
        );
    }
}